import { Button, Group, Modal, Stack } from '@mantine/core'
import { get, noop } from 'lodash'
import React, { useState } from 'react'

import { IDialog } from '../Dialog'

export interface TConfirmationDialog extends IDialog {
  children?: React.ReactNode
  title?: string
  text?: React.ReactNode
  confirmText?: string
  cancelText?: string
  deleteText?: string
  danger?: boolean
  isDisabled?: boolean
  onConfirm?: () => void
  onClick?: () => void
}
const ConfirmationDialog = (props: TConfirmationDialog): React.ReactElement => {
  const {
    children = <div></div>,
    title = '',
    text = '',
    confirmText = i18n.t('confirm', 'Bestätigen'),
    cancelText = i18n.t('cancel', 'Abbrechen'),
    deleteText = i18n.t('delete', 'Löschen'),
    onClick = noop,
    onConfirm = noop,
    size,
    danger,
    isDisabled,
    ...rest
  } = props

  // TODO: fallback until completed
  // return React.cloneElement(children, { onClick: props.onClick })

  const [isOpen, setIsOpen] = useState(false)

  if (
    !React.isValidElement(children)
    // || (!isFunction(get(children, "props.onClick")) &&
    //   !isFunction(props.onClick))
  ) {
    console.warn(
      'components/ConfirmationDialog: children is not a single element or does not have a onClick handler.',
    )
    return <>{children}</>
  }

  const open = (e): void => {
    e.stopPropagation()
    e?.preventDefault()
    setIsOpen(true)
  }

  const close = (e?): void => {
    e?.stopPropagation()
    e?.preventDefault()
    setIsOpen(false)
  }

  const confirm = async (e?): Promise<void> => {
    e?.stopPropagation()
    e?.preventDefault()
    const func =
      onConfirm ||
      get(children, 'props.onClick') ||
      get(children, 'props.onChange') ||
      onClick ||
      noop

    await func()

    close(e)
  }

  if (isDisabled) {
    return React.cloneElement(children as React.ReactElement, {
      onClick: confirm,
      onChange: confirm,
    })
  }

  return (
    <>
      <Modal
        opened={isOpen}
        onClose={close}
        title={title}
        size={size}
        padding="md"
        zIndex={9001}
      >
        <Stack>
          <div>{text}</div>
          <Group position="apart">
            <div></div>
            <Group>
              <Button variant="subtle" onClick={close}>
                {cancelText}
              </Button>
              <Button
                variant="filled"
                color={danger ? 'red' : 'blue'}
                onClick={confirm}
              >
                {danger ? deleteText : confirmText}
              </Button>
            </Group>
          </Group>
        </Stack>
      </Modal>

      {React.cloneElement(children as React.ReactElement, {
        onClick: open,
        onChange: open,
      })}
    </>
  )
}

export default ConfirmationDialog
